// START IMPORTS
import { constants } from '../../appConstants';
// END IMPORTS

// START CONSTANTS
const contactProLink =
  'https://www.beenverified.com/rf/search/contact?advancedSearch=true&source=contactSearch';
const unclaimedMoneyLink =
  'https://www.beenverified.com/rf/dashboard/unclaimed-money';
const memberPerksLink = 'https://www.beenverified.com/rf/dashboard/rewards';
const requestApiAccessLink =
  'https://docs.google.com/forms/d/e/1FAIpQLScugCNnjhri8oJkTf6SqaPigmlWRviTcVewj55RsyhS-l3Pqw/viewform';
const needMoreReportsLink =
  'https://docs.google.com/forms/d/e/1FAIpQLSdsuNU5p7oD3CX3VvEMrBP1kvG3AodnhSvDytnb36rDVpcpxg/viewform';
const testimonialsLink = 'https://www.beenverified.com/reviews/';
const pressLink = 'https://www.beenverified.com/press/';
const careersLink = 'https://www.ltvco.com/careers/';
// END CONSTANTS

// START HELPER_FUNCTIONS
export const generateFooterLinks = ({
  contactUsHandler,
  isInternationalTestUser,
  oar1946Variation,
}: {
  contactUsHandler: () => void;
  isInternationalTestUser?: boolean;
  oar1946Variation?: string;
}) => {
  const {
    links: { affiliateLink, aboutLink, doDontsLink, FaqLink, supportLink },
  } = constants;

  const hideContactUs = oar1946Variation === 'OAR-1946_variation_1';
  const moveDosAndDonts = oar1946Variation === 'OAR-1946_variation_2';

  const dosAndDontsLink = { text: "Do's & Dont's", href: doDontsLink };

  const supportLinks = [
    { text: 'Customer Care', href: supportLink },
    { text: 'Contact Us', href: '#', onClick: contactUsHandler },
    dosAndDontsLink,
    { text: "FAQ's", href: FaqLink },
  ].filter((link) => {
    if (hideContactUs && link.text === 'Contact Us') {
      return false;
    }
    if (moveDosAndDonts) {
      return false;
    }
    return true;
  });

  const commonSections = [
    ...(supportLinks.length > 0
      ? [
          {
            title: 'SUPPORT',
            links: supportLinks,
          },
        ]
      : []),
    {
      title: 'COMPANY',
      links: [
        { text: 'About BeenVerified', href: aboutLink },
        { text: 'Testimonials', href: testimonialsLink },
        { text: 'Press', href: pressLink },
        { text: 'Careers', href: careersLink },
      ],
    },
  ];

  if (isInternationalTestUser) {
    return [
      {
        title: 'RESOURCES',
        links: [
          { text: 'Affiliates', href: affiliateLink },
          ...(moveDosAndDonts ? [dosAndDontsLink] : []),
        ],
      },
      ...commonSections,
    ];
  }

  return [
    {
      title: 'MORE SEARCHES',
      links: [
        { text: 'Contact Pro', href: contactProLink },
        { text: 'Unclaimed Money', href: unclaimedMoneyLink },
      ],
    },
    {
      title: 'RESOURCES',
      links: [
        { text: 'Affiliates', href: affiliateLink },
        { text: 'Member Perks', href: memberPerksLink },
        { text: 'Request API Access', href: requestApiAccessLink },
        {
          text: 'Need More Reports?',
          href: needMoreReportsLink,
        },
        ...(moveDosAndDonts ? [dosAndDontsLink] : []),
      ],
    },
    ...commonSections,
  ];
};
// END HELPER_FUNCTIONS
